import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["actions"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useContext } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Transition from 'react-transition-group/Transition';
import { ContextPanelConsumer, WidthContext } from '@atlaskit/editor-common/ui';
import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
import { findChildrenByType } from '@atlaskit/editor-prosemirror/utils';
import { akEditorBreakoutPadding, akEditorContextPanelWidth, akEditorDefaultLayoutWidth, akEditorSwoopCubicBezier, akEditorWideLayoutWidth, FULL_PAGE_EDITOR_TOOLBAR_HEIGHT } from '@atlaskit/editor-shared-styles';
import { N30 } from '@atlaskit/theme/colors';
import { getChildBreakoutModes } from '../../utils/document';
import WithEditorActions from '../WithEditorActions';
var ANIM_SPEED_MS = 500;
var EDITOR_WIDTH = akEditorDefaultLayoutWidth + akEditorBreakoutPadding;
var WIDE_EDITOR_WIDTH = akEditorWideLayoutWidth + akEditorBreakoutPadding;
var FULLWIDTH_MODE = 'full-width';
var WIDE_MODE = 'wide';
var absolutePanelStyles = css({
  position: 'absolute',
  right: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  height: "calc(100% - ".concat(FULL_PAGE_EDITOR_TOOLBAR_HEIGHT(), ")")
});
var checkTableExistsInDoc = function checkTableExistsInDoc(editorView) {
  var tableNodeSchema = editorView.state.schema.nodes.table;
  var findResult = findChildrenByType(editorView.state.doc, tableNodeSchema);
  return findResult.length > 0;
};
export var shouldPanelBePositionedOverEditor = function shouldPanelBePositionedOverEditor(editorWidth, panelWidth, editorView) {
  var lineLength = editorWidth.lineLength,
    _editorWidth$containe = editorWidth.containerWidth,
    containerWidth = _editorWidth$containe === void 0 ? 0 : _editorWidth$containe,
    contentBreakoutModes = editorWidth.contentBreakoutModes;
  var editorNotFullWidth = !(lineLength && lineLength > akEditorDefaultLayoutWidth);
  var hasSpaceForPanel = !contentBreakoutModes.length && containerWidth >= panelWidth * 2 + EDITOR_WIDTH;
  var hasSpaceForWideBreakoutsAndPanel = !contentBreakoutModes.includes(FULLWIDTH_MODE) && contentBreakoutModes.includes(WIDE_MODE) && containerWidth >= panelWidth * 2 + WIDE_EDITOR_WIDTH;
  if (!editorView) {
    return editorNotFullWidth && (hasSpaceForPanel || hasSpaceForWideBreakoutsAndPanel);
  } else {
    // when custom table width feature flag is on,
    // there are scenarios when a table has attr layout default, but width is in full-width or very wide
    // but in this case we still want the shouldPanelBePositionedOverEditor return false
    // previous logic is returning false when table layout default
    // but when custom table width feature flag is one, we want to return false whenever there is a table in the doc
    var isTableInDoc = checkTableExistsInDoc(editorView);
    return editorNotFullWidth && (hasSpaceForPanel || hasSpaceForWideBreakoutsAndPanel) && !isTableInDoc;
  }
};
var panelHidden = css({
  width: 0
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var panel = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "".concat(akEditorContextPanelWidth, "px"),
  height: '100%',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transition: "width ".concat(ANIM_SPEED_MS, "ms ").concat(akEditorSwoopCubicBezier),
  overflow: 'hidden',
  boxShadow: "inset 2px 0 0 0 ".concat("var(--ds-border, ".concat(N30, ")"))
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var content = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  transition: "width 600ms ".concat(akEditorSwoopCubicBezier),
  boxSizing: 'border-box',
  padding: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-200, 16px)", " 0px"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "".concat(akEditorContextPanelWidth, "px"),
  height: '100%',
  overflowY: 'auto'
});
export var SwappableContentArea = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SwappableContentArea, _React$PureComponent);
  var _super = _createSuper(SwappableContentArea);
  function SwappableContentArea() {
    var _this;
    _classCallCheck(this, SwappableContentArea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      mounted: false,
      currentPluginContent: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "focusEditor", function () {
      var editorView = _this.props.editorView;
      if (editorView && !editorView.hasFocus()) {
        var _editorView$focus;
        (_editorView$focus = editorView.focus) === null || _editorView$focus === void 0 || _editorView$focus.call(editorView);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "showPluginContent", function () {
      var pluginContent = _this.props.pluginContent;
      var currentPluginContent = _this.state.currentPluginContent;
      if (!currentPluginContent) {
        return;
      }
      return jsx(Transition, {
        timeout: _this.state.mounted ? ANIM_SPEED_MS : 0,
        in: !!pluginContent,
        mountOnEnter: true,
        unmountOnExit: true,
        onExited: function onExited() {
          return _this.unsetPluginContent();
        }
      }, currentPluginContent);
    });
    _defineProperty(_assertThisInitialized(_this), "showProvidedContent", function (isVisible) {
      var children = _this.props.children;
      if (!children) {
        return;
      }
      return jsx(Transition, {
        timeout: _this.state.mounted ? ANIM_SPEED_MS : 0,
        in: isVisible,
        mountOnEnter: true,
        unmountOnExit: true,
        onExiting: _this.focusEditor
      }, children);
    });
    return _this;
  }
  _createClass(SwappableContentArea, [{
    key: "unsetPluginContent",
    value: function unsetPluginContent() {
      this.setState({
        currentPluginContent: undefined
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // use this to trigger an animation
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        editorWidth = _this$props.editorWidth,
        editorView = _this$props.editorView;
      var width = akEditorContextPanelWidth;
      var userVisible = !!this.props.visible;
      var visible = userVisible || !!this.state.currentPluginContent;
      return jsx(ContextPanelConsumer, null, function (_ref) {
        var broadcastWidth = _ref.broadcastWidth,
          broadcastPosition = _ref.broadcastPosition,
          positionedOverEditor = _ref.positionedOverEditor;
        var contextPanelWidth = visible ? width : 0;
        var newPosition = editorWidth ? shouldPanelBePositionedOverEditor(editorWidth, width, editorView) : false;
        broadcastWidth(contextPanelWidth);
        (newPosition && visible) !== positionedOverEditor && broadcastPosition(newPosition && visible);
        return jsx("div", {
          css: [panel, !visible && panelHidden,
          /**
           * Only use absolute position for panel when screen size is wide enough
           * to accommodate breakout content and editor is not in wide mode.
           */
          newPosition && absolutePanelStyles],
          "data-testid": "context-panel-panel",
          "aria-labelledby": "context-panel-title",
          role: "dialog"
        }, jsx("div", {
          "data-testid": "context-panel-content",
          css: [content, !visible && panelHidden]
        }, _this2.showPluginContent() || _this2.showProvidedContent(userVisible)));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.pluginContent !== state.currentPluginContent) {
        return _objectSpread(_objectSpread({}, state), {}, {
          currentPluginContent: props.pluginContent
        });
      }
      return null;
    }
  }]);
  return SwappableContentArea;
}(React.PureComponent);

// TODO: ED-17837 We have this workaround because we do
// not have access to the pluginInjectionApi at this location.
// It might be that we need to inject the pluginInjectionApi
// via context so that we can use it in this file (similar to
// WithEditorActions). To be investigated further.

// @ts-ignore
var widthPluginKey = {
  key: 'widthPlugin$',
  getState: function getState(state) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return state['widthPlugin$'];
  }
};

// @ts-ignore
var contextPanelPluginKey = {
  key: 'contextPanelPluginKey$',
  getState: function getState(state) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return state['contextPanelPluginKey$'];
  }
};
function ContextPanelWithActions(_ref2) {
  var actions = _ref2.actions,
    props = _objectWithoutProperties(_ref2, _excluded);
  var eventDispatcher = actions._privateGetEventDispatcher();
  var editorView = actions._privateGetEditorView();
  var _useContext = useContext(WidthContext),
    width = _useContext.width;
  if (!eventDispatcher) {
    return jsx(SwappableContentArea, _extends({
      editorView: editorView
    }, props));
  }
  return (
    // @ts-ignore - 'WithPluginState' cannot be used as a JSX component.
    // This error was introduced after upgrading to TypeScript 5
    jsx(WithPluginState, {
      eventDispatcher: eventDispatcher,
      plugins: {
        contextPanel: contextPanelPluginKey,
        widthState: widthPluginKey
      },
      render: function render(_ref3) {
        var contextPanel = _ref3.contextPanel,
          widthState = _ref3.widthState;
        var firstContent = contextPanel && contextPanel.contents.find(Boolean);
        var editorWidth = _objectSpread(_objectSpread({}, widthState), {}, {
          containerWidth: width,
          contentBreakoutModes: editorView ? getChildBreakoutModes(editorView.state.doc, editorView.state.schema) : []
        });
        return jsx(SwappableContentArea, _extends({}, props, {
          editorView: editorView,
          pluginContent: firstContent,
          editorWidth: editorWidth
        }));
      }
    })
  );
}
export default function ContextPanel(props) {
  return jsx(WithEditorActions, {
    render: function render(actions) {
      return jsx(ContextPanelWithActions, _extends({
        actions: actions
      }, props));
    }
  });
}